import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IAvailableOffer {
  banner: string;
  description?: any;
  id?: string;
  uid: any;
  offerId: string;
  offerType: number | string;
}
interface IOffersResponse {
  response: {
    activeOffers: IAvailableOffer[];
    expiredOffers: IAvailableOffer[];
    redeemedOffers: IAvailableOffer[];
  };
}

interface OffersState {
  activeOffers: IAvailableOffer[];
  expiredOffers: IAvailableOffer[];
  redeemedOffers: IAvailableOffer[];
  isHash: boolean;
  loading: boolean;
  filter: any;
}

const initialState: OffersState = {
  activeOffers: [],
  expiredOffers: [],
  redeemedOffers: [],
  isHash: false,
  loading: true,
  filter: [],
};

export const offersSlice = createSlice({
  name: "offersSlice",
  initialState,
  reducers: {
    resetLoadedOffers: () => initialState,
    setLoadedOffers: (state, action: PayloadAction<IOffersResponse>) => {
      state.activeOffers = action.payload.response.activeOffers;
      state.expiredOffers = action.payload.response.expiredOffers;
      state.redeemedOffers = action.payload.response.redeemedOffers;
      // state.loading = false;
    },
    setHashOffers: (state, action) => {
      state.isHash = action.payload;
    },
    setLoadingOffers: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setFilterData: (state, action) => {
      const newFilterItem = action.payload;
      state.filter = state.filter.filter(
        (item: any) => item.filter !== newFilterItem.filter
      );
      state.filter.push(newFilterItem);
    },

    resetFilter: (state) => {
      state.filter = [];
    },
  },
});

export const {
  setLoadedOffers,
  resetLoadedOffers,
  setHashOffers,
  setLoadingOffers,
  setFilterData,
  resetFilter,
} = offersSlice.actions;

export const offersReducer = offersSlice.reducer;
